<template>
  <div>
    <h3 v-html="feature.properties.address"></h3>
    <button class="dbutton" @click="popupClicked(feature.properties.address)">Get Directions</button>
  </div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  props: {
    feature: {
      required: true,
      type: Object,
    },
  },
  methods: {
    popupClicked(address) {
        let link = 'https://www.google.com/maps?saddr=Current+Location&daddr=' + encodeURI(address)
        window.open(link, "_blank") || window.location.replace(link)
    },
  },
})
</script>

<style lang="sass">
.mapboxgl-popup-close-button
  padding: 1px 5px
.mapboxgl-popup-content
  background: #3195f8
  color: #fff
  text-align: center
  font-family: 'Roboto', sans-serif
.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip
  border-top-color: #50a0fc
.mapboxgl-popup-anchor-top .mapboxgl-popup-tip
  border-bottom-color: #50a0fc
.mapboxgl-popup-anchor-top-right .mapboxgl-popup-tip
  border-bottom-color: #50a0fc
.mapboxgl-popup-anchor-right .mapboxgl-popup-tip
  border-left-color: #50a0fc
.mapboxgl-popup-anchor-left .mapboxgl-popup-tip
  border-right-color: #50a0fc
.mapboxgl-popup-anchor-bottom-right .mapboxgl-popup-tip
  border-top-color: #50a0fc
.mapboxgl-popup-anchor-bottom-left .mapboxgl-popup-tip
  border-top-color: #50a0fc
.mapboxgl-popup-anchor-top-left .mapboxgl-popup-tip
  border-bottom-color: #50a0fc
.dbutton
  background: #fff
  color: #3195f8
  padding: 5px 10px
  margin-top: 5px
  border-radius: 2px
</style>